import { stringify } from 'query-string';
import { template, unset } from 'lodash';
import axios from './client';

const PARTNER = template('/partner/<%= id %>');
const MANAGE_SEARCH = '/manage/partners';
const MANAGE_PARTNERS_SEARCH = '/manage/partners/search';
const MANAGE_PARTNER = template('/manage/partner/<%= id %>');
const PARTNER_W9 = template('/partner/<%= id %>/w9');
const PARTNER_W9_PDF = template('/manage/partner/<%= id %>/w9');
const PARTNER_PAYOUT_TAX = template('/partner/<%= id %>/payout-tax');
const TEMPLATE_W9_PDF_URL = '/template/w9/pdf';

export function read(id) {
  return axios.get(PARTNER({ id }));
}

export function update(payload) {
  let data = { ...payload };
  if (payload instanceof FormData) {
    data = Object.fromEntries(payload);
  }
  unset(data, 'id');
  const id = payload instanceof FormData ? payload.get('id') : payload.id;
  return axios.post(PARTNER({ id }), data);
}

export function manageSearch(params = {}) {
  return axios.get(MANAGE_SEARCH, { params });
}

export function searchPartners(params = {}) {
  return axios.get(MANAGE_PARTNERS_SEARCH, { params });
}

export function manageRead(id) {
  return axios.get(MANAGE_PARTNER({ id }));
}

export function manageUpdate(id, params) {
  return axios.post(MANAGE_PARTNER({ id }), params);
}

/**
 * Get partner's w9 info
 * @param id
 * @returns {Promise}
 */
export function partnerW9(id) {
  return axios.get(PARTNER_W9({ id }));
}

/**
 * Get template W-9 PDF from server
 * @returns {Promise}
 */
export function getTemplateW9Pdf() {
  return axios.get(TEMPLATE_W9_PDF_URL);
}

/**
 * Get existing partner W-9 PDF from server
 * @param id
 * @returns {Promise}
 */
export function getPartnerW9Pdf(id) {
  return axios.get(PARTNER_W9_PDF({ id }));
}

/**
 * Save partner W-9 PDF to server
 * @param formData
 * @returns {Promise}
 */
export function savePartnerW9PDF(formData) {
  const id = formData.get('id');
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(PARTNER_W9({ id }), formData, { headers });
}

/**
 * Update partner W-9 status to server
 * @param formData
 * @returns {Promise}
 */
export function updatePartnerW9Status(formData) {
  const id = formData.get('id');
  const headers = { 'Content-Type': 'multipart/form-data' };
  return axios.post(PARTNER_W9_PDF({ id }), formData, { headers });
}

/**
 * Get partner's payout method
 * @param id
 * @returns {Promise}
 */
export function partnerPayoutTax(id) {
  return axios.get(PARTNER_PAYOUT_TAX({ id }));
}

/**
 * Update partner's payout method
 * @param payload
 * @returns {Promise}
 */
export function partnerPayoutChange(payload) {
  let data = stringify(payload, { arrayFormat: 'bracket' });
  if (payload instanceof FormData) data = payload;
  const id = payload instanceof FormData ? payload.get('id') : payload.id;
  return axios.post(PARTNER_PAYOUT_TAX({ id }), data);
}
